import { DataTableComponent } from '@farris/ui-datatable';
import { of } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';
import { FavoriteAction, FAVORITE_FIELD_NAME } from '../lookup-displaytype';
import { LookupGridResult } from '../lookup-grid-options';
import { LookupGridComponent } from '../lookup-grid.component';
import { LookupSelectionService } from './lookup-selection.service';

export class DataTableEventManager {

    private lookupSelectionSer: LookupSelectionService;

    private _sortState = null;

    constructor(private ins: LookupGridComponent) {
        this.lookupSelectionSer = this.ins.lookupSelectionSer;
    }

    conditionsChange(conditions) {
        this.ins.conditions = conditions;
        if (conditions && conditions.length === 1 && conditions[0].code == '*') {
            this.ins.conditions = [];
            this.onSearch({ field: '*', value: conditions[0].value });    
        } else {
            this.onSearch();
        }
    }

    onSearch($event: { field: string; value: string } = { field: '*', value: '' }) {
        if ($event && $event.field !== '*' && !$event.value) {
            this.ins.messagerService.warning(this.ins.mustWriteSomething);
            return;
        }

        const p = {
            pageInfo: { pageIndex: 1, pageSize: this.ins.gridOptions.pageSize },
            search: $event
        };

        if (this._sortState) {
            const {sortName, sortOrder} = this._sortState;
            if (sortName) {
                p['sortName'] = sortName;
                p['sortOrder'] = sortOrder;
            }
        }

        if (this.ins.uri) {
            if (!this.ins.searching) {
                this.ins.searching = true;

                if (this.ins['navNodePathCode']) {
                    p['navNodePathCode'] = this.ins['navNodePathCode'];
                }

                this.ins.showLoading();
                this.ins.httpMgr.getData(p, 'list').pipe(
                    catchError(err => {
                        this.ins.searching = false;
                        return of({ "_ERROR_": err });
                    }),
                    tap(() => {
                        this.ins.searching = false;
                    })
                ).subscribe(
                    data => {
                        this.ins.searching = false;
                        this.ins.closeLoading();
                        if (!data['_ERROR_']) {
                            this._loadData(data);
                        } else {
                            throw new Error(data['_ERROR_']);
                        }
                    }
                );
            }
        } else {
            if (this.ins.enableMultiFieldSearch) {
                this.ins.query.emit({ conditions: this.ins.conditions, instance: this.ins })
            } else {
                this.ins.search.emit(p);
            }
        }
    }

    private _loadData(data: LookupGridResult) {
        const self = this.ins;
        self.closeLoading();
        self.favHelper.updateFavoritesStatus(data.items);
        self.loadDataTableData(data);
        // éä¸­æ°æ®
        this.ins.selectionMgr.selectCurrentValue();
    }

    bindDataTableEvent() {
        const self = this.ins;
        const dt = self.componentRef.instance as DataTableComponent;

     
        dt.selectedRow.subscribe((e: any) => {
            if (this.ins.singleSelect) {
                this.lookupSelectionSer.clearSelections();
            }
            this.ins.checkedChange.emit({ data: [e.data], isCheck: true });
            this.lookupSelectionSer.updateSelections([e.data]);
            dt.cd.detectChanges();
        });
    

        dt.unSelectRow.subscribe(e => {
            this.lookupSelectionSer.unSelect(e.data[self.idField]);
            this.ins.checkedChange.emit({ data: [e.data], isCheck: false });
        });

        dt.checkAll.subscribe((e: boolean) => {
            this.lookupSelectionSer.updateSelections(dt.data, e);
            this.ins.checkedChange.emit({ data: dt.data, isCheck: e });
        });

        dt.pageChanged.subscribe((e: any) => {
            if (self.uri) {
                this.ins.showLoading();
                self.httpMgr.getData(e, 'list').subscribe((data: LookupGridResult) => {
                    this._loadData(data);
                    this.ins.closeLoading();
                });
            } else {
                self.pagerChanged.emit(self.httpMgr.buildQueryParams(e, 'list'));
            }
        });

        dt.pageSizeChanged.subscribe(e => {
            if (self.uri) {
                this.ins.showLoading();
                self.httpMgr.getData(e, 'list').subscribe(
                    data => {
                        this._loadData(data);
                        this.ins.closeLoading();
                    },
                    err => {
                        self.closeLoading();
                    }
                );
            } else {
                self.pagerChanged.emit(self.httpMgr.buildQueryParams(e, 'list'));
            }
        });

        dt.search.subscribe((e: any) => {
            // if (JSON.stringify(self._searchState || {}) !== JSON.stringify(e || {})) {
            //     this.ins.searching = false;
            // }
            self._searchState = {...(e || {})};
            this.onSearch(e);
        });

        dt.searchValueChange.subscribe((e: any) => {
            if (e && e.value) {
                self._searchState = {...e};
            } else {
                self._searchState = null;
                // 729813 æç´¢æ¡è¾å¥ç©ºå­ç¬¦ä¸æ°æ®æºä¸ä¸ºç©ºæ¶ï¼æªè§¦åè§¦åæç´¢
                this.onSearch();
            }
        });

        // åå»äºä»¶
        dt.rowDblClick.subscribe((rowData: any) => {
            if (self.gridOptions.singleSelect) {
                // this.lookupSelectionSer.updateSelections([rowData]);
                self.selectItem(rowData);
            }
        });

        // æ¶èäºä»¶
        if(!dt.cellClick.observers.length) {
            dt.cellClick.subscribe((e: any) => {
                if (e.col.field === FAVORITE_FIELD_NAME) {
                    const classList = e.event.target['classList'];
                    if (classList.contains('f-lookup-favorite')) {
                        e.event.stopPropagation();
                        self.items.forEach(item => {
                            const id = self.utils.getValue(self.idField, item);
                            if (id === self.utils.getValue(self.idField, e.row)) {
                                item[FAVORITE_FIELD_NAME] = !item[FAVORITE_FIELD_NAME];
                            }
                        });
                        dt.loadData({
                            pageSize: self.gridOptions.pageSize,
                            pageIndex: self.gridOptions.pageIndex,
                            total: self.gridOptions.total,
                            data: self.gridOptions.items
                        });

                        // æ´æ°æ¶èæ°æ®
                        const faction = e.row[FAVORITE_FIELD_NAME] ? FavoriteAction.add : FavoriteAction.delete;

                        if (faction ===  FavoriteAction.add) {
                            this.ins.favoriteItems = [...this.ins.favoriteItems, e.row];
                        } else {
                            this.ins.favoriteItems = this.ins.favoriteItems.filter(n => {
                                return self.utils.getValue(self.idField, n) !== self.utils.getValue(self.idField, e.row);
                            });
                        }

                        this.lookupSelectionSer.updateFavoriteData(e.row, faction);
                    }
                }
            });
        }

        dt.columnSorted.subscribe((sort: { sortName: string; sortOrder: any }) => {

            this._sortState = sort;

            if (!this.ins.remoteSort) {
                return;
            }

            const { sortName, sortOrder } = { ...sort };

            const col = this.ins.columns.find(n => n.field === sortName);

            const _sortName = col ? col.fieldPath ? col.fieldPath : col.field : sortName;

            const param = {
                sortName: _sortName,
                sortOrder,
                search: self._searchState,
                pageInfo: {
                    pageSize: self.pageSize,
                    pageIndex: 1
                }
            };
            self.showLoading();
            self.httpMgr.getData(param, 'search').subscribe(d => {
                self.loadDataTableData(d);
                self.closeLoading();
                // éä¸­æ°æ® TFS 615008
                this.ins.selectionMgr.selectCurrentValue();
            });
        });

        dt.clearSearchValue.subscribe(() => {
            self._searchState = null;
            this.onSearch();
        });

        dt.cellStyler = (val: any) => {
            const { field } = val;
            if (field === FAVORITE_FIELD_NAME) {
                return {
                    'text-overflow': 'unset'
                };
            }

            return null;
        }
    }
}

